import axios from 'axios';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { FaPhone, FaKey } from 'react-icons/fa';

function VerificationPage({ setMobile }) {
    const [showOtp, setShowOtp] = useState(false);
    const [userOtp, setUserOtp] = useState('');
    const [generatedOtp, setGeneratedOtp] = useState(null);
    const [mobileNumber, setMobileNumber] = useState('');
    const [sending, setSending] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    const timerRef = useRef(null);
    const API_URL = process.env.REACT_APP_API_URL;

    // Countdown for resend
    useEffect(() => {
        if (resendTimer <= 0) {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
            return;
        }
        timerRef.current = setInterval(() => {
            setResendTimer(t => t - 1);
        }, 1000);
        return () => { if (timerRef.current) clearInterval(timerRef.current); };
    }, [resendTimer]);

    const sendOtp = async () => {
        if (sending || resendTimer > 0) return;
        if (!/^\d{10}$/.test(mobileNumber)) {
            toast.error('Enter 10 digit mobile number');
            return;
        }
        setSending(true);
        try {
            const response = await axios.post(`${API_URL}/verify-user`, { mobileNumber });
            setShowOtp(true);
            setGeneratedOtp(String(response.data.otp));
            toast.success(response.data.message || 'OTP sent');
            setResendTimer(30); // 30s cooldown
        } catch (e) {
            console.error(e);
            toast.error('Failed to send OTP');
        } finally {
            setSending(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (verifying) return;
        if (!/^\d{6}$/.test(userOtp)) {
            toast.error('Enter valid 6 digit OTP');
            return;
        }
        setVerifying(true);
        try {
            if (userOtp === generatedOtp) {
                localStorage.setItem('mobile', mobileNumber);
                setMobile(mobileNumber);
                toast.success('OTP Verified Successfully!');
            } else {
                toast.error('Invalid OTP!');
            }
        } finally {
            setVerifying(false);
        }
    };

    return (
        <Fragment>
            <div className="modal fade vertically-center" id="loginmodal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content login-modal-content">
                        <div className="modal-header py-2 border-0">
                            <h6 className="modal-title fw-bold ms-auto" id="loginModalLabel" style={{letterSpacing:'0.5px'}}>VERIFY MOBILE NUMBER</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body pt-0" aria-live="polite">
                            {/* Mobile Field */}
                            <div className={`bb-field ${mobileNumber && !/^\d{10}$/.test(mobileNumber)?'error':''}`}>
                                <FaPhone className="bb-ico" />
                                <input
                                    type="tel"
                                    inputMode="numeric"
                                    maxLength={10}
                                    placeholder="Mobile Number *"
                                    value={mobileNumber}
                                    onChange={(e)=> setMobileNumber(e.target.value.replace(/[^0-9]/g,'').slice(0,10))}
                                    aria-label="Mobile Number"
                                />
                                {mobileNumber && mobileNumber.length!==10 && <span className="bb-msg">10 digits required</span>}
                            </div>
                            {/* Get / Resend OTP button */}
                            <button
                                type="button"
                                className="w-100 btn btn-danger mb-3 mt-2"
                                onClick={sendOtp}
                                disabled={sending || resendTimer>0}
                            >
                                {sending ? <span className="spinner-border spinner-border-sm" /> : showOtp ? (resendTimer>0?`Resend in ${resendTimer}s`:'Resend OTP') : 'Get OTP'}
                            </button>
                            {showOtp && (
                                <>
                                    <div className={`bb-field ${userOtp && !/^\d{6}$/.test(userOtp)?'error':''}`}>
                                        <FaKey className="bb-ico" />
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            maxLength={6}
                                            placeholder="Enter 6 digit OTP *"
                                            value={userOtp}
                                            onChange={(e)=> setUserOtp(e.target.value.replace(/[^0-9]/g,'').slice(0,6))}
                                            aria-label="OTP"
                                        />
                                        {userOtp && userOtp.length!==6 && <span className="bb-msg">6 digits required</span>}
                                    </div>
                                    <button
                                        type="button"
                                        className="w-100 btn btn-danger mb-2"
                                        onClick={handleVerifyOtp}
                                        disabled={verifying || !/^\d{6}$/.test(userOtp)}
                                        data-bs-dismiss={userOtp === generatedOtp ? 'modal' : undefined}
                                    >
                                        {verifying ? <span className="spinner-border spinner-border-sm" /> : 'VERIFY & CONTINUE'}
                                    </button>
                                </>
                            )}
                            <div className="small text-muted text-center mt-1" style={{fontSize:'11px'}}>We send OTP only for verification. It is free & fast.</div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    );
}

export default VerificationPage;
